import React from 'react'
import HistorySlider from '../Components/slider/HistorySlider'

function About() {
    return (
        <>
            <div className='mt-[80px]'>
                <div className='relative'>
                    <img src="/assets/about/bg1.svg" className='w-full' alt="" />
                    <div className='absolute md:bottom-[60px] bottom-[10px] left-[50%] translate-x-[-50%]'>
                        <h2 className="font-[700] font-manrope md:text-[50px] text-[30px] text-[#FFFFFF] tracking-[3px] text-center">About Us</h2>
                        <p className="font-[500] font-manrope text-[16px] text-[#FFFFFF] tracking-[3px] text-center">HOME-ABOUT US</p>
                    </div>
                </div>
            </div>
            <section className='md:px-[90px] his-slider md:pb-[142px] pb-[80px] px-[20px] md:pt-[120px] pt-[40px]'>
                <HistorySlider />
            </section>
            <section className='vision-section md:pt-[100px] pt-0 md:px-[90px] px-[20px] md:pb-[178px] pb-[80px]'>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-[72px] px-[20px] md:px-[0] items-center">
                    <div>
                        <img src="/assets/about/img2.png" alt="" className="w-full" />
                    </div>
                    <div>
                        <p className='font-[500] font-inter text-[18px] text-[#FF6000]'>VISION</p>
                        <h6 className='font-[700] font-manrope lg:text-[50px] text-[30px] text-[#000000] pb-[24px]'>
                            Our Core Vision <br /> and
                            <span className='text-[#FF6000]'>Mission</span>
                        </h6>
                        <p className="pb-[20px] font-[700] font-manrope text-[31px] leading-[34px] tracking-[2px] text-[#000000]">Vision</p>
                        <p className="font-[500] font-manrope text-[16px] leading-[34px] pb-[30px] text-[#000000]">
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper.
                        </p>
                        <p className="pb-[20px] font-[700] font-manrope text-[31px] leading-[34px] tracking-[2px] text-[#000000]">Mission
                        </p>
                        <p className="font-[500] font-manrope text-[16px] leading-[34px] text-[#000000]">
                            Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper. Suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor.
                        </p>
                    </div>
                </div>
            </section>
            <section className='md:pt-[100px] md:pb-[156px] pb-[80px] pt-[50px] md:px-[110px] px-[20px]'>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-[72px] px-[20px] md:px-[0] items-center">
                    <div className='flex flex-col gap-[45px]'>
                        <div className='flex flex-row gap-[50px] items-start'>
                            <img src="/assets/about/point.svg" alt="" />
                            <div>
                                <h6 className="font-[700] font-manrope lg:text-[64px] text-[40px] leading-[46px] uppercase text-[#000000] pb-[15px]">15+</h6>
                                <p className="font-[500] font-manrope text-[24px] text-[#FF6000]">Volunteers</p>
                            </div>
                        </div>
                        <div className='flex flex-row gap-[50px] items-start'>
                            <img src="/assets/about/point.svg" alt="" />
                            <div>
                                <h6 className="font-[700] font-manrope lg:text-[64px] text-[40px] leading-[46px] uppercase text-[#000000] pb-[15px]">50M+</h6>
                                <p className="font-[500] font-manrope text-[24px] text-[#FF6000]">Groups</p>
                            </div>
                        </div>
                        <div className='flex flex-row gap-[50px] items-start'>
                            <img src="/assets/about/point.svg" alt="" />
                            <div>
                                <h6 className="font-[700] font-manrope lg:text-[64px] text-[40px] leading-[46px] uppercase text-[#000000] pb-[15px]">5M+</h6>
                                <p className="font-[500] font-manrope text-[24px] text-[#FF6000]">Special Events</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <img src="/assets/about/img3.png" alt="" className="w-full" />
                    </div>
                </div>
            </section>
        </>
    )
}

export default About